import { HotelInfoModel } from '@/__generated';
import HotelRewardRating from '@/components/App/HotelRewardRating';
import HotelJapaneseName from '@/components/App/Hotels/HotelJapaneseName';
import HotelStar from '@/components/App/Hotels/HotelStar';
import React from 'react';

type Props = { hotelInfo: HotelInfoModel };

export default function HotelDetailTitle({ hotelInfo }: Props) {
  return (
    <div className="row y-gap-20 justify-between items-end pt-10">
      <div className="col-12">
        <div className="row x-gap-20">
          <div className="col">
            <h1 className="text-30 sm:text-25 fw-600 x-gap-4">
              {hotelInfo.nameEn}
              <HotelJapaneseName name={hotelInfo.name} addBefore="-" />
              <HotelStar star={hotelInfo.starRating || 0} />
            </h1>
          </div>
          <div className="col-auto">
            <HotelRewardRating rate={hotelInfo.reviewRating} />
          </div>
        </div>
        <div className="row x-gap-20 y-gap-20 items-center">
          <div className="col">
            <div className="d-flex items-center text-15 text-light-1">
              <i className="icon-location-2 text-16 mr-5" />
              <span className="mr-5">{hotelInfo.address}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
